export { renderMenuGroupHeader_unstable as renderMenuGroupHeader } from '@fluentui/react-menu';
